import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { NewsPostDetailApi } from '../news-post-detail/api/news-post-detail-api';
import { NewsPostListApi } from '../news-post-list/api/news-post-list-api';

export class NewsPostApi {
    constructor(protected baseUrl: string) {
        this.NewsPostList = new NewsPostListApi(this.baseUrl);
        this.NewsPostDetail = new NewsPostDetailApi(this.baseUrl);
    }

    public NewsPostList: NewsPostListApi;
    public NewsPostDetail: NewsPostDetailApi;

    public deleteNewsPost(id: number): Promise<ApiResult<void>> {
        return safeRequest(() => request.delete(`${this.baseUrl}/news-posts/${id}`), noop);
    }
}
